
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remyndCategoryPartnerMap",
      function () {
        return require("private-next-pages/remyndCategoryPartnerMap/index.tsx");
      }
    ]);
  